import { render } from "./Hunting.vue?vue&type=template&id=4cf81f1f&scoped=true&ts=true"
import script from "./Hunting.vue?vue&type=script&lang=ts"
export * from "./Hunting.vue?vue&type=script&lang=ts"

import "./Hunting.vue?vue&type=style&index=0&id=4cf81f1f&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf81f1f"]])

export default __exports__